module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "detail-file"
    }
  }, [(_vm.fileData) ? _c('x-table', {
    staticStyle: {
      "background-color": "#fff"
    },
    attrs: {
      "cell-bordered": false,
      "content-bordered": true
    }
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "background-color": "#F7F7F7"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("附件名")]), _vm._v(" "), _c('th', [_vm._v("上传用户")]), _vm._v(" "), _c('th', [_vm._v("操作")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.fileData), function(item, key) {
    return _c('tr', {
      key: key
    }, [_c('td', [_vm._v(_vm._s(item.fileName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.uploadPeople))]), _vm._v(" "), _c('td', [_c('x-button', {
      attrs: {
        "mini": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.showFile(key, _vm.fileList[key].src, _vm.fileList[key].type, item.fileName)
        }
      }
    }, [_vm._v("查看")]), _vm._v(" "), _c('img', {
      staticClass: "previewer-demo-img",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "src": _vm.fileList[key].src,
        "width": "100"
      }
    })], 1)])
  }))]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b2c7068","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/File.vue
// module id = wHYT
// module chunks = 0